import { observer } from "mobx-react-lite";
import * as React from "react";
import { ImagesListEditor } from "src/components/ImagesListEditor/ImagesListEditor";
import { MdmUploader, MdmUploadStore } from "src/components/MdmUploader";
import { castToFiles } from "src/components/MdmUploader/castToFiles";
import { UploaderViewDefault } from "src/components/MdmUploader/UploaderViewDefault";
import { ActivateCallback } from "src/types/ActivateCallback";
import { ZMdmFileEd } from "src/types/ZMdmFile";

import { ZTypeDef } from "../ZAttrMeta";
import { ZAttrUploader } from "./ZAttrComponent";

/**
 * Поддерживаются типы: ZMdmFile и ZMdmFile[]
 */

type PropsAttrUploader = {
  attrType: ZTypeDef;
  value: unknown;
  onChange?(newValue: unknown): void;
  disabled?: boolean;
  component: ZAttrUploader;
  activateCallback?: ActivateCallback;
  onBlur: () => void;
};

export const AttrUploader: React.FC<PropsAttrUploader> = observer((props) => {
  // Здесь нет никакой специальной логики и рендера. Только проксирование данных.
  const {
    value,
    onChange,
    disabled,
    component,
    attrType,
    activateCallback,
    onBlur,
  } = props;
  const isImage: boolean =
    ((attrType.name === "file" && attrType.image) ||
      (attrType.name === "array" &&
        attrType.item?.type.name === "file" &&
        attrType.item.type.image)) ??
    false;
  const isSingle = attrType.name !== "array";
  const store: MdmUploadStore = React.useMemo(
    () =>
      new MdmUploadStore({
        isImage: component.isImage,
        maxCount:
          attrType.name === "array" ? (attrType.maxCount ?? undefined) : 1,
        maxSize: component.maxSize,
        accept: component.accept ?? undefined,
        onChange: (list: ZMdmFileEd[]) => {
          onBlur();
          if (isSingle) {
            const src = list[0];
            onChange?.(src || null);
          } else {
            onChange?.(list);
          }
        },
      }),
    [],
  );
  React.useEffect(() => {
    store.setExtFiles(castToFiles(value) ?? []);
  }, [value]);
  React.useEffect(() => {
    store.setDisabled(!!disabled);
  }, [disabled]);
  return (
    <MdmUploader store={store}>
      {isImage ? (
        <ImagesListEditor
          items={store.frames}
          disabled={disabled}
          onRemove={(index) => store.remove(index)}
          onOpen={() => store.setModalOpen(true)}
          activateCallback={activateCallback}
        />
      ) : (
        <UploaderViewDefault
          store={store}
          activateCallback={activateCallback}
          disabled={disabled}
        />
      )}
    </MdmUploader>
  );
});
